import React, { useRef } from "react";
import "./uploadButton.scss";
import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";

interface UploadButtonProps {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  handleFileChange,
  disabled,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (disabled) return;
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="upload_btn_container">
      <Button
        icon={<UploadOutlined />}
        block
        type="default"
        onClick={handleClick}
        disabled={disabled}
        aria-label="Upload Resume"
      >
        Upload Resume
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        // accept=".pdf, .docx" temporarily disabled docx and doc
        accept=".pdf"
        onChange={handleFileChange}
        disabled={disabled}
        aria-label="Upload Resume"
      />
    </div>
  );
};

export default UploadButton;
